import type { Schema, Storage } from '@wix/wix-data-schema-types'

export enum CollectionType {
  USER = 'USER',
  DB_DRIVER = 'DB_DRIVER',
  APP = 'APP',
  EXTERNAL_DB_DRIVER = 'EXTERNAL_DB_DRIVER',
  DYNAMIC_APP_SCHEMA = 'DYNAMIC_APP_SCHEMA',
  STATIC_APP_SCHEMA = 'STATIC_APP_SCHEMA',
}

const storageToType: Record<Storage, CollectionType> = {
  driver: CollectionType.DB_DRIVER,
  docstore: CollectionType.USER,
  app: CollectionType.APP,
  external: CollectionType.EXTERNAL_DB_DRIVER,
  dynamicApplication: CollectionType.DYNAMIC_APP_SCHEMA,
  staticAppSchema: CollectionType.STATIC_APP_SCHEMA,
}

export const getCollectionType = (schema: Schema): CollectionType =>
  (schema.storage && storageToType[schema.storage]) ?? CollectionType.USER
